






export default {
  name: "BaseDivider",
};
